import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

const RoleInput: React.FC = () => {
  const [CustomRoleName, setRoleName] = useState('');
  const [description, setDescription] = useState('');
  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);

  const handleSubmit = async () => {
    if (!CustomRoleName || !description) {
      message.error('Please fill in all fields');
      return;
    }   

    try {
      const token = await fetchToken();
      await axios.post(`${API_URL}/api/Roles`, 
      { CustomRoleName, description }, 
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      message.success('Role added successfully');
      setRoleName('');
      setDescription('');
    } catch (error) {
      message.error('Failed to add role');
    }
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Form.Item label="Role Name" required>
        <Input
          value={CustomRoleName}
          onChange={(e) => setRoleName(e.target.value)}
          placeholder="Enter role name"
        />
      </Form.Item>
      <Form.Item label="Description" >
        <Input.TextArea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter role description"
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Add Role
        </Button>
      </Form.Item>
    </Form>
  );
};

export default RoleInput;